import { fetch } from "core/util";

const getCzRss = () => fetch.doGetPlain(`https://patalie.cz/feed/feed4axa`);
const getSkRss = () => fetch.doGetPlain(`https://patalie.sk/feed/feed4axa`);

export default {
    getCzRss,
    getSkRss,
};
